import axios from "@/axios";
import apiUrl from "@/axios/config";

const funds = {
  //获取所有汇率
  async getAllExhangeRate(params = {}) {
    return await axios.post("/uc/deposit/getRate", params, {
      des: "直客wap获取注资汇率",
      sTime: new Date().getTime()
    });
  },
  // 获取注资汇率
  async getDepositRateInfo(parmas = {}) {
    return await axios.post("/uc/deposit/rate", parmas, {
      des: "直客wap获取注资汇率",
      sTime: new Date().getTime()
    });
  },
  // 获取注资支持银行
  async getDepositBankList(params) {
    return await axios.post("/uc/deposit/web/deposit/banks", params, {
      des: "直客wap获取注资支持银行",
      sTime: new Date().getTime()
    });
  },
  // 根据卡号获取银行名称
  async getBankNameByNumber(params) {
    return await axios.get(
      "/uc/bank/matchingBank",
      { params },
      { des: "直客wap根据卡号获取银行名称", sTime: new Date().getTime() }
    );
  },
  // 获取当前存
  async getCurrentIncome(params) {
    return await axios.post("/uc/gold/list", params, {
      des: "直客wap获取当前存款",
      sTime: new Date().getTime()
    });
  },
  // 获取当前取
  async expenditureExpenditure(params) {
    return await axios.post("/uc/gold/list", params, {
      des: "直客wap获取当前取款",
      sTime: new Date().getTime()
    });
  },
  // 获取当前取
  async giveUp(params) {
    return await axios.post("/uc/gold/giveup", params, {
      des: "直客wap出金取消申请",
      sTime: new Date().getTime()
    });
  },
  // 获取sms
  async getSms(params) {
    return await axios.post("/uc/sendcode2", params, {
      des: "直客wap获取sms",
      sTime: new Date().getTime()
    });
  },
  // 提交订单
  async orderSubmit(params) {
    return await axios.post("/uc/deposit/web/deposit/shortcut", params, {
      des: "直客wap提交订单",
      sTime: new Date().getTime()
    });
  },
  // 获取支持提现的银行
  async getChoiceBankList(params) {
    return await axios.post("/uc/gold/choiceBankList", params, {
      des: "直客wap获取支持提现的银行",
      sTime: new Date().getTime()
    });
  },
  // 获取支持提现的银行对应的银行信息
  async getBankInfo(params) {
    return await axios.post("/uc/gold/choiceBank", params, {
      des: "直客wap获取支持提现的银行对应的银行信息",
      sTime: new Date().getTime()
    });
  },
  //获取支付列表
  async getPayList(params = {}) {
    return await axios.post("/sysgetPayurl/list", params, {
      des: "获取支付列表",
      sTime: new Date().getTime()
    });
  },
  // 提现
  async withdraw(params) {
    return await axios.post("/uc/gold/submitGold", params, {
      des: "直客wap提现",
      sTime: new Date().getTime()
    });
  },
  // 获取收币地址
  async getBindCodeList(params) {
    return await axios.get(
      "/uc/user/bindcode/list",
      { params },
      { des: "获取收币地址", sTime: new Date().getTime() }
    );
  },
  // 添加收币地址
  async addBindCodeList(params) {
    return await axios.post("/uc/user/bindcode/add", params, {
      des: "添加收币地址",
      sTime: new Date().getTime()
    });
  },
  // 修改收币地址
  async updateBindCodeList(params) {
    return await axios.post("/uc/user/bindcode/update", params, {
      des: "修改收币地址",
      sTime: new Date().getTime()
    });
  },
  // 删除收币地址
  async deleteBindCodeList(params) {
    return await axios.post("/uc/user/bindcode/del", params, {
      des: "删除收币地址",
      sTime: new Date().getTime()
    });
  },
  // 出金手续费确认
  async poundageConfirm(params) {
    return await axios.post("/uc/gold/poundageConfirm", params, {
      des: "直客wap出金手续费确认",
      sTime: new Date().getTime()
    });
  },
  //用户中心-真实账户-资金管理-注资记录查询
  async getDepositList(params) {
    return await axios.post("/uc/deposit/query", params, {
      des: "直客wap注资记录查询",
      sTime: new Date().getTime()
    });
  },
  //用户中心——资金管理——出金
  async getOutGoldList(params) {
    return await axios.post("/uc/gold/list", params, {
      des: "直客wap出金",
      sTime: new Date().getTime()
    });
  },
  //用户中心--资金管理--银行汇款
  async BankRemittance(params) {
    return await axios.post("/uc/deposit/bank/add", params, {
      des: "直客wap银行汇款",
      sTime: new Date().getTime()
    });
  },
  //用户中心--网上支付--支付通道列表
  async applyList(params) {
    return await axios.post("/uc/pay/getPassageInfo", params, {
      des: "直客wap支付通道列表",
      sTime: new Date().getTime()
    });
  },
  //用户中心——调取商城支付通道——调用商城通道支付
  async invokeMallPay(params) {
    return await axios.post("/uc/pay/invokeMallPay", params, {
      des: "直客wap调用商城通道支付",
      sTime: new Date().getTime()
    });
  },
  //用户中心——调取商城支付通道——获取通道支持银行
  async getPassageBank(passageId) {
    return await axios.post("/uc/pay/getPassageBank", passageId, {
      des: "直客wap获取通道支持银行",
      sTime: new Date().getTime()
    });
  },
  //获取商城支付跳转链接
  async getShopLink(params) {
    return await axios.post("/uc/gold/rechargeBuyMallUrl", params, {
      des: "直客wap获取商城支付跳转链接 ",
      sTime: new Date().getTime()
    });
  },
  // 获取用户信息判断是否绑定手机、IDCard
  async getIdentityInfo(params = "") {
    return await axios.post("/uc/gold/isAuthentication", params, {
      des: "直客wap获取用户信息判断是否绑定手机、IDCard",
      sTime: new Date().getTime()
    });
  },
  // 获取提现界面的信息
  async getApplyGoldInfo(params = "") {
    return await axios.post("/uc/gold/applyGold", params, {
      des: "直客wap获取提现界面的信息",
      sTime: new Date().getTime()
    });
  },
  // 获取USDT汇率计算
  async getUsdtRate(params = "") {
    return await axios.get("/common/getRate", params, {
      des: "USDT汇率",
      sTime: new Date().getTime()
    });
  },
  //获取快捷支付跳转链接
  async AntPurseLink(params = "") {
    return await axios.post(
      "/uc/deposit/web/deposit/antWalletQuickLogin",
      params,
      { des: "直客wap获取快捷支付跳转链接", sTime: new Date().getTime() }
    );
  },
  //获取支付通道是否打开     接口已废弃
  // async getjfGoldPageList(params) {
  //   return await axios.post('/uc/goldPage/jfGoldPageList', params, { des: '直客wap获取支付通道是否打开 ', sTime: new Date().getTime() })
  // },
  //获取通道是否被禁用    接口已废弃
  // async getPageStatus(params) {
  //   return await axios.post('/uc/goldPage/jfGoldPageStatus', params, { des: '直客wap获取通道是否被禁用', sTime: new Date().getTime() })
  // },
  //获取通道列表
  async getPayAggregatedList(params) {
    return await axios.post(
      "/uc/deposit/web/deposit/getPayAggregatedList",
      params,
      { des: "直客wap获取通道列表", sTime: new Date().getTime() }
    );
  },
  //提交注资跳转
  async submitDeposit(params) {
    return await axios.post(
      "/uc/deposit/web/deposit/createAggregatedOrder",
      params,
      { des: "直客wap提交注资跳转", sTime: new Date().getTime() }
    );
  },
  //获取转账支付注资金额
  async getArtificialCardType(params = "") {
    return await axios.post(
      "/uc/deposit/web/deposit/getArtificialCardType",
      params,
      { des: "直客wap获取转账支付注资金额", sTime: new Date().getTime() }
    );
  },
  //提交转账支付
  async createArtificialPayOrder(params) {
    return await axios.post(
      "/uc/deposit/web/deposit/createArtificialPayOrder",
      params,
      { des: "直客wap提交转账支付 ", sTime: new Date().getTime() }
    );
  },
  //根据订单号获取url
  async getArtificialPayUrl(params) {
    return await axios.post(
      "/uc/deposit/web/deposit/getArtificialPayUrl",
      params,
      { des: "直客wap根据订单号获取url", sTime: new Date().getTime() }
    );
  },
  //用户取消出金
  async giveup(params) {
    return await axios.post("/uc/gold/giveup", params, {
      des: "直客wap用户取消出金 ",
      sTime: new Date().getTime()
    });
  },
  //网上充值
  async createEpupayOrder(params) {
    return await axios.post(
      "/uc/deposit/web/deposit/createEpupayOrder",
      params,
      { des: "直客wap网上充值", sTime: new Date().getTime() }
    );
  },
  // 提示
  async isNeedDeductGold(params = "") {
    return await axios.post("/uc/gold/isNeedDeductGold", params, {
      des: "直客wap提示",
      sTime: new Date().getTime()
    });
  },
  //用户中心-入金方式列表
  async getAllQuickPaymentType(params) {
    return await axios.post("/uc/payMode/GetAllQuickPaymentType", params);
  },
  //用户中心-入金方式列表-创建订单
  async quickCreateOrder(params) {
    return await axios.post("/uc/payMode/QuickCreateOrder", params);
  },
  //用户中心-入金方式列表第二种-创建订单
  async quickCreateOrder2(params) {
    let data = Object.assign({}, params);
    delete data.uuid;
    return await axios({
      method: "post",
      url: "/uc/payMode/QuickCreateOrder2",
      headers: { uuid: params.uuid },
      data: data
    });
  },
  //用户中心-入金方式列表-取消订单
  async userUpdateCancelOrder(params) {
    return await axios.post("/uc/payMode/UserUpdateCancelOrder", params);
  },
  //用户中心-入金方式列表-确认付款(只针对蚂蚁钱包)
  async confirmationPayment(params) {
    return await axios.post("/uc/payMode/ConfirmationPayment", params);
  },
  //用户中心-入金方式列表-获取订单详情
  async getOrderDetail(params) {
    return await axios.post("/uc/payMode/GetOrderDetail", params);
  },
  //用户中心-资金管理- 入金页面显示   接口已废弃
  // jfdepositPage(params) {
  //   let data;

  //   function S4() {
  //     return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  //   }

  //   function guid() {
  //     return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
  //   }
  //   $.ajax({
  //     url: apiUrl.API_BASE_URL + '/uc/goldPage/jfdepositPage?flag=' + params,
  //     headers: { 'Content-Type': 'application/json;charset=utf8', 'uuid': guid() },
  //     type: 'post',
  //     async: false,
  //     dataType: 'JSON',
  //     success: function(res) {
  //       data = res;
  //     },
  //     error: function(err) {
  //       console.error(err.responseText);
  //     }
  //   });
  //   return data;
  // },
  async isShow(params) {
    return await axios.post("uc/firstChargeActivity/isShow", params);
  },
  // 获取注销账号信息
  async getCancellationInfo(params) {
    return await axios.get(
      "/uc/user/userinfo/condition",
      { params },
      { des: "注销条件获取", sTime: new Date().getTime() }
    );
  },
  //三要素注销验证
  async checkThreeElements(params) {
    return await axios.get(
      "/uc/checkThreeElements",
      { params },
      { des: "三要素注销验证", sTime: new Date().getTime() }
    );
  },
  //用户中心-注销账户
  async getCancelLation(params) {
    return await axios.post("/uc/user/userinfo/cancellation", params);
  },
  //获取撮合订单详情
  async getWithdrawalDetail(params) {
    return await axios.post("/uc/gold/withdrawalDetail", params, {
      des: "获取撮合订单详情",
      sTime: new Date().getTime()
    });
  },
  //确认撮合订单
  async paymentSuccessful(params) {
    return await axios.post("/uc/gold/paymentSuccessful", params, {
      des: "确认撮合订单",
      sTime: new Date().getTime()
    });
  },
  //获取出金提示内容
  async getWithdrawTips(params = {}) {
    return await axios.post("/web/goldrule/getcontent", params, {
      des: "获取出金提示内容",
      sTime: new Date().getTime()
    });
  },
  //获取出金时手续费比例
  async getServiceCharge(params) {
    return await axios.get("uc/gold/getServiceCharge", params, {
      des: "获取出金时手续费比例",
      sTime: new Date().getTime()
    });
  },
  //关闭交易现金活动
  async getCloseTradeCashActivity(params) {
    return await axios.post("uc/gold/closeTradeCashActivity", params, {
      des: "关闭交易现金活动",
      sTime: new Date().getTime()
    });
  },
  //获取提现方式等信息
  async getWithdrawMode(params) {
    return await axios.get("uc/gold/qrcode", params, {
      des: "获取提现方式等信息",
      sTime: new Date().getTime()
    });

    return new Promise((res, rej) => {
      res({
        data: {
          Status: "0",
          IsSuccess: true,
          Data: {
            mjActualMoney: 1099.8,
            rmbActualMoney: 8055.17,
            rmbActualRoundMoney: 8055.0,
            banks: [],
            receiptModeList: {
              "1": "银行卡取款",
              "2": "数字钱包取款"
            },
            poundage: 122.2,
            mjMoney: 1222.0,
            isSmallWithdrawal: "0"
          },
          Token: ""
        }
      });
    });
  },
  //获取OSS参数信息
  async getendpoint(params) {
    return await axios.get("common/getendpoint", params, {
      des: "获取OSS参数信息",
      sTime: new Date().getTime()
    });
  },
  //获取OSS验证签名
  async getCallbackSign(params) {
    return await axios.get("common/callbackSign", params, {
      des: "获取OSS验证签名",
      sTime: new Date().getTime()
    });
  },
  //获取图片url
  async getPictureUrl(params) {
    return await axios.post("common/getPictureUrl", params, {
      des: "获取图片url",
      sTime: new Date().getTime()
    });
  },
  //出金图片上传ftp
  upload2sftp(params) {
    return jQuery.ajax({
      type: "post",
      data: params,
      xhrFields: { withCredentials: true },
      crossDomain: true,
      processData: false,
      contentType: false,
      dataType: "json",
      url: apiUrl.API_BASE_URL + "common/upload2sftp"
    });
    //return await axios.post('common/upload2sftp', params, { des: '图片上传ftp', sTime: new Date().getTime() })
  }
};

export default funds;



// WEBPACK FOOTER //
// ./src/api/funds.js